module.exports = __webpack_public_path__ + "static/media/SIDRA SAADOON.ac8806b4.png";